import axios from "./axios"

import { useAppStore } from "@/stores/AppStore";

axios.interceptors.request.use(
  config => {
    const appStore = useAppStore();
    appStore.loading = true;
    
    config.headers.Authorization = `Bearer ${process.env.VUE_APP_API_TOKEN}` 
    return config
  },
  error => {
    const appStore = useAppStore();
    appStore.loading = false;
    Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    const appStore = useAppStore();
    appStore.loading = false;

    return response
  },
  async error => {
    const appStore = useAppStore();
    appStore.loading = false;
    return Promise.reject(error)
  })

export default axios
